import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import React from "react";

import FormField from "@/components/atoms/FormField";
import { MDButton } from "@/components/atoms/MDButton";
import { OrderFormData } from "@/components/screens/OrderFormPage/types";
import { OrderDataTabMessages } from "@/messages/order-form-page/order-data-tab.messages";

type Props = {
  isVisible: boolean;
  handleClose: () => void;
  messages: OrderDataTabMessages;
  disabled: boolean;
};

export default function ShippedDialog({ isVisible, handleClose, messages, disabled }: Props) {
  const { values, errors, handleChange, setFieldValue } = useFormikContext<OrderFormData>();

  const handleCancel = () => {
    setFieldValue("shippingObject", values.shippingObject);
    setFieldValue("shippingTrackingUrl", values.shippingTrackingUrl);
    setFieldValue("shippingVolumeType", values.shippingVolumeType);
    setFieldValue("shippingVolumes", values.shippingVolumes);

    handleClose();
  };

  return (
    <Dialog open={isVisible} onClose={handleClose}>
      <DialogTitle>{messages.shippingDialogTitle}</DialogTitle>

      <DialogContent>
        <Grid container spacing={3}>
          <Grid size={12}>
            <FormField
              variant="standard"
              name="shippingObject"
              label={messages.shippingObjectLabel}
              value={values.shippingObject}
              onChange={handleChange}
              fullWidth
              disabled={disabled}
              error={!!errors.shippingObject}
              inputProps={{ maxLength: 500 }}
            />
          </Grid>

          <Grid size={12}>
            <FormField
              variant="standard"
              name="shippingTrackingUrl"
              label={messages.shippingTrackingUrlLabel}
              value={values.shippingTrackingUrl}
              onChange={handleChange}
              fullWidth
              disabled={disabled}
              error={!!errors.shippingTrackingUrl}
              inputProps={{ maxLength: 1000 }}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <FormField
              variant="standard"
              name="shippingVolumeType"
              label={messages.shippingVolumeTypeLabel}
              value={values.shippingVolumeType}
              onChange={handleChange}
              fullWidth
              disabled={disabled}
              error={!!errors.shippingVolumeType}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormField
              variant="standard"
              name="shippingVolumes"
              label={messages.shippingVolumesLabel}
              value={values.shippingVolumes}
              onChange={handleChange}
              fullWidth
              disabled={disabled}
              error={!!errors.shippingVolumes}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <MDButton variant="gradient" color="light" onClick={handleCancel}>
          {messages.cancelButton}
        </MDButton>
        <MDButton variant="gradient" color="dark" disabled={disabled} onClick={handleClose}>
          {messages.updateButton}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
